@if (label) {
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400"
         [ngClass]="{
           'text-gray-400': control.disabled,
           'text-gray-700 dark:text-gray-400': !control.disabled
         }"
  >
    {{ label }} @if (required || (control && control.hasValidator(Validators.required))) {
    <span class="text-red-600">*</span>
  }
  </label>
}
<div class="relative">
  @if (prefix) {
    <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500 z-10">{{ prefix }}</div>
  }
  <input
    appPreventNumberScroll
    [formControl]="control"
    [name]="name"
    type="{{ type }}"
    placeholder="{{ placeholder }}"
    mask="{{ mask }}"
    thousandSeparator="{{ thousandSeparator }}"
    [allowNegativeNumbers]="allowNegativeNumbers"
    [attr.max]="max !== undefined ? max : null"
    [ngClass]="{'pl-8': prefix, 'pr-10': clearable && hasValue()}"
    class="
    dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400
    focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30
    dark:focus:border-brand-800 focus:shadow-focus-ring disabled:border-gray-100 disabled:placeholder:text-gray-300 dark:disabled:border-gray-800 dark:disabled:placeholder:text-white/15
  "
  >

  <!-- Clear button -->
  @if (clearable && hasValue() && !control.disabled) {
    <button
      type="button"
      class="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-gray-600"
      (click)="clearInput()"
    >
      <lucide-icon [name]="XCircle" class="w-4 h-4"></lucide-icon>
    </button>
  }

  @if (control.invalid && (control.dirty || control.touched)) {
    <span class="absolute top-1/2 right-3.5 -translate-y-1/2 text-error-500">
      <lucide-icon size="18" [name]="CircleAlert"></lucide-icon>
    </span>
  }

</div>

@if (control.invalid && (control.dirty || control.touched)) {
  <p class="text-theme-xs text-error-500 mt-1.5">
    @for (errorKey of control.errors ? Object.keys(control.errors) : []; track errorKey) {
      @if (control.errors) {
        <div>{{ errorKey | errorMessage:control.errors[errorKey] }}</div>
      }
    }
  </p>
}

@if (helpText && !(control.invalid && (control.dirty || control.touched))) {
  <p class="text-theme-xs text-gray-500 mt-1.5">{{ helpText }}</p>
}
